<template>
    <template v-if="hasAuth">
        <slot />
    </template>
    <slot
        v-else
        name="else"
    />
</template>

<script>
import { useUserStore } from '@store/user';

export default {
    name: 'RoleGuard',
    props: {
        guarded: {
            type: Array,
            required: true,
        },
    },
    setup(props) {
        const user = useUserStore();

        const hasAuth = computed(() => {
            return user.hasAuth(props.guarded);
        });

        return {
            hasAuth,
        };
    },
};
</script>
